import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <div className="space-y-6 text-gray-300 text-sm leading-relaxed" data-id="element-56">
    <h2 className="text-2xl font-bold text-white" data-id="element-57">Política de Privacidad</h2>
    <p className="text-xs text-gray-500" data-id="element-58">
      Última actualización: {new Date().toLocaleDateString('es-CL')}
    </p>

    <section className="space-y-2" data-id="element-59">
      <h3 className="text-lg font-semibold text-white" data-id="element-60">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-61">
        Recopilamos únicamente la información necesaria para procesar tu compra
        y entregarte el material digital: nombre, correo electrónico y datos de
        pago. No almacenamos datos de tarjetas de crédito ni débito en nuestros
        servidores.
      </p>
    </section>

    <section className="space-y-2" data-id="element-62">
      <h3 className="text-lg font-semibold text-white" data-id="element-63">
        2. Uso de la Información
      </h3>
      <p data-id="element-64">Tu información personal se utiliza exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 ml-2" data-id="element-65">
        <li data-id="element-66">Procesar y entregar tu compra digital.</li>
        <li data-id="element-67">
          Enviarte actualizaciones relacionadas con el producto adquirido.
        </li>
        <li data-id="element-68">Brindarte soporte en caso de que lo solicites.</li>
      </ul>
    </section>

    <section className="space-y-2" data-id="element-69">
      <h3 className="text-lg font-semibold text-white" data-id="element-70">
        3. Protección de Datos
      </h3>
      <p data-id="element-71">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>
    </section>

    <section className="space-y-2" data-id="element-72">
      <h3 className="text-lg font-semibold text-white" data-id="element-73">
        4. Compartir Información
      </h3>
      <p data-id="element-74">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de pago
        necesarios para procesar tu transacción.
      </p>
    </section>

    <section className="space-y-2" data-id="element-75">
      <h3 className="text-lg font-semibold text-white" data-id="element-76">5. Cookies</h3>
      <p data-id="element-77">
        Utilizamos cookies para mejorar tu experiencia de navegación y analizar
        el tráfico del sitio. Puedes desactivar las cookies en la configuración
        de tu navegador.
      </p>
    </section>

    <section className="space-y-2" data-id="element-78">
      <h3 className="text-lg font-semibold text-white" data-id="element-79">6. Tus Derechos</h3>
      <p data-id="element-80">
        De acuerdo con la legislación chilena vigente, tienes derecho a acceder,
        rectificar, cancelar y oponerte al tratamiento de tus datos personales
        en cualquier momento.
      </p>
    </section>
  </div>;
const termsContent = <div className="space-y-6 text-gray-300 text-sm leading-relaxed" data-id="element-81">
    <h2 className="text-2xl font-bold text-white" data-id="element-82">Términos y Condiciones</h2>
    <p className="text-xs text-gray-500" data-id="element-83">
      Última actualización: {new Date().toLocaleDateString('es-CL')}
    </p>

    <section className="space-y-2" data-id="element-84">
      <h3 className="text-lg font-semibold text-white" data-id="element-85">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-86">
        Al acceder y realizar una compra en este sitio, aceptas estos términos y
        condiciones en su totalidad. Si no estás de acuerdo con alguna parte, te
        recomendamos no realizar la compra.
      </p>
    </section>

    <section className="space-y-2" data-id="element-87">
      <h3 className="text-lg font-semibold text-white" data-id="element-88">2. Producto Digital</h3>
      <p data-id="element-89">
        El "Protocolo Adiós Deudas Chile 2025" es un producto de información
        digital con fines educativos. El material proporcionado no constituye
        asesoría legal, financiera ni profesional personalizada.
      </p>
    </section>

    <section className="space-y-2" data-id="element-90">
      <h3 className="text-lg font-semibold text-white" data-id="element-91">3. Resultados</h3>
      <p data-id="element-92">
        Los resultados mencionados en testimonios y ejemplos son casos
        individuales y no garantizan resultados idénticos. Los resultados pueden
        variar según la situación financiera, el esfuerzo y las circunstancias
        de cada persona.
      </p>
    </section>

    <section className="space-y-2" data-id="element-93">
      <h3 className="text-lg font-semibold text-white" data-id="element-94">
        4. Garantía de Devolución
      </h3>
      <p data-id="element-95">
        Ofrecemos una garantía de devolución de 7 días desde la fecha de compra.
        Para solicitar un reembolso, debes demostrar que descargaste y aplicaste
        el material. Los reembolsos se procesan dentro de 5 a 10 días hábiles.
      </p>
    </section>

    <section className="space-y-2" data-id="element-96">
      <h3 className="text-lg font-semibold text-white" data-id="element-97">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-98">
        Todo el contenido del producto está protegido por derechos de autor.
        Queda prohibida su reproducción, distribución o reventa total o parcial
        sin autorización expresa por escrito.
      </p>
    </section>

    <section className="space-y-2" data-id="element-99">
      <h3 className="text-lg font-semibold text-white" data-id="element-100">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-101">
        No nos hacemos responsables por decisiones financieras o legales tomadas
        en base al contenido del producto. Recomendamos siempre consultar con un
        profesional calificado para situaciones específicas.
      </p>
    </section>

    <section className="space-y-2" data-id="element-102">
      <h3 className="text-lg font-semibold text-white" data-id="element-103">
        7. Legislación Aplicable
      </h3>
      <p data-id="element-104">
        Estos términos se rigen por las leyes de la República de Chile.
        Cualquier controversia será sometida a los tribunales ordinarios de
        justicia de Santiago de Chile.
      </p>
    </section>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy-900 py-8 text-center text-gray-500 text-sm border-t border-navy-800" data-id="element-105">
        <div className="max-w-4xl mx-auto px-4" data-id="element-106">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-107">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold-500 transition-colors underline underline-offset-2" data-id="element-108">
              Política de Privacidad
            </button>
            <span className="text-navy-700" data-id="element-109">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold-500 transition-colors underline underline-offset-2" data-id="element-110">
              Términos y Condiciones
            </button>
          </div>
          <p data-id="element-111">
            © {new Date().getFullYear()} Protocolo Adiós Deudas Chile. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-60" data-id="element-112">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc. Los
            resultados mostrados no son típicos y pueden variar según la
            situación de cada persona.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-113">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-114">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-navy-800 border border-navy-700 rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-115">
              <div className="flex items-center justify-between p-5 border-b border-navy-700" data-id="element-116">
                <span className="text-white font-bold text-lg" data-id="element-117">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </span>
                <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-navy-700" data-id="element-118">
                  <X size={20} data-id="element-119" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-64px)]" data-id="element-120">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}